/* eslint-disable no-nested-ternary */
import { ITableData, Header } from 'src/pages/analytics/simulator/pricing-simulator/types/generic-table.model';
import getUpdatedData from '../../utils/numeric-calculations';

export default function getNumericInputChange({
    tableMetaData,
    columnMetadata,
    rowStateData,
    newValue
}:
    {
        tableMetaData: ITableData;
        rowStateData: any;
        columnMetadata: Header;
        newValue: number;
    }) {
    const selectedParentRow: any = [rowStateData];
    const updateRowData = (metaData): any[] =>
        metaData.map((currentData: any) => ({
            parent: {
                data:
                    getUpdatedData(
                        currentData,
                        columnMetadata,
                        tableMetaData,
                        newValue
                    )
            },
            children:
                currentData.children && currentData.children.length
                    ? updateRowData(currentData.children)
                    : []
        }));
    return updateRowData(selectedParentRow);
}